import { FiMail } from 'react-icons/fi';
import { useTranslation } from 'react-i18next';
import styles from './Portfolio.module.css';
import { useSiteProfile } from './ProfileContext';

const skillGroups = [
  ['backend', 'Java', 'Spring Boot', 'Spring Security', 'MyBatis', 'REST APIs'],
  ['frontend', 'React', 'JavaScript', 'Ant Design', 'Responsive UI'],
  ['ai', 'RAG', 'Hybrid Retrieval', 'Prompt Design', 'Evaluation'],
  ['engineering', 'MySQL', 'Docker', 'Azure Pipelines', 'Git'],
];

const AboutPage = () => {
  const { t } = useTranslation();
  const profile = useSiteProfile();
  return (
  <div className={styles.pageWrap}>
    <header className={`${styles.pageHero} ${styles.aboutHero}`}>
      <p className={styles.eyebrow}>{t('about.eyebrow')}</p>
      <h1>{profile.aboutTitle}</h1>
      <p>{profile.aboutIntro}</p>
    </header>

    <section className={styles.aboutGrid}>
      <div className={styles.aboutPortrait} aria-hidden="true">
        <span>{profile.initials}</span>
        <p>{profile.location.toUpperCase()}<br />{profile.country.toUpperCase()}</p>
      </div>
      <div className={styles.aboutCopy}>
        <p>{profile.paragraph1}</p>
        <p>{profile.paragraph2}</p>
        <p>{profile.paragraph3}</p>
        <div className={styles.socialLinks}>
          <a href={`mailto:${profile.email}`}><FiMail /> {t('footer.email')}</a>
        </div>
      </div>
    </section>

    <section className={styles.skillsSection}>
      <div className={styles.sectionHeading}>
        <div>
          <p className={styles.eyebrow}>{t('about.toolkit')}</p>
          <h2>{t('about.technologies')}</h2>
        </div>
      </div>
      <div className={styles.skillGrid}>
        {skillGroups.map(([title, ...skills]) => (
          <article key={title}>
            <h3>{t(`about.groups.${title}`)}</h3>
            <ul>{skills.map((skill) => <li key={skill}>{skill}</li>)}</ul>
          </article>
        ))}
      </div>
    </section>
  </div>
  );
};

export default AboutPage;
